import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/site';
import SectionHeading from '@/components/base/SectionHeading';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,22rem)_minmax(0,1fr)] lg:gap-16">
          <div>
            <SectionHeading
              eyebrow="常见问题"
              title="关于围观，你可能想问"
              desc="关于内容范围、隐私处理、投稿反馈，这里先一次性说清楚。"
            />
            <div className="hidden rounded-lg border border-background-200 bg-background-50 p-5 lg:block">
              <p className="text-sm font-semibold text-foreground-950">还有别的疑问？</p>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                欢迎直接给我们留言，关于内容、合作或建议都可以聊。
              </p>
              <Link
                to="/about#contact"
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700"
              >
                去联系页面
                <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true"></i>
              </Link>
            </div>
          </div>

          <dl className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={faq.question}>
                  <dt>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6 md:py-5"
                    >
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {faq.question}
                      </span>
                      <i
                        className={`shrink-0 text-xl leading-none text-primary-500 transition-transform ${
                          isOpen ? 'ri-subtract-line' : 'ri-add-line'
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </dt>
                  {isOpen && (
                    <dd className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6 md:pb-6">
                      {faq.answer}
                    </dd>
                  )}
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
}